// extracted by mini-css-extract-plugin
export default {"container":"NvProjectsPageWriteUp_container__p505K"};